import { DateTime } from "luxon";
import type { FilterBarProps } from "shared-ui/src/components/filter-bar/FilterBar";
import { lookBackShortcutItems } from "shared-ui/src/components/DateRangeCalendarFilterShortcuts";

export const FILTER_CATEGORY_DATE_RANGE = "invoiceDateRange";

export const INVOICE_DATE_RANGE_MAX_YEARS = 5;

export const INVOICE_PORTAL_CUTOFF_DATE = DateTime.utc(2023, 1, 1);

export function getInvoiceDateRangeMinDate(now: DateTime = DateTime.utc()) {
  return DateTime.max(
    INVOICE_PORTAL_CUTOFF_DATE,
    now.minus({ years: INVOICE_DATE_RANGE_MAX_YEARS }),
  );
}

function getDefaultDateRange(): [string, string] {
  // Matches the page's previous default lookback shortcut ("This Month").
  const [start, end] = lookBackShortcutItems[1].getValue({
    isValid: () => true,
  });
  return [start!.toISODate()!, end!.toISODate()!];
}

export const DEFAULT_FILTER: FilterBarProps = {
  include: { [FILTER_CATEGORY_DATE_RANGE]: getDefaultDateRange() },
  exclude: {},
};

export const FILTER_LABELS: Record<string, string> = {
  salesOrder: "Sales Order",
  currency: "Currency",
  storefront: "Storefront",
};
